import * as React from "react";
import { useState } from "react";

import { FieldRenderProps, FieldWrapper } from "@progress/kendo-react-form";
import { Button } from "@progress/kendo-react-buttons";
import {
  Input,
  MaskedTextBox,
  NumericTextBox,
  Checkbox,
  ColorPicker,
  Switch,
  RadioGroup,
  TextArea,
  Rating,
  InputClearValue,
} from "@progress/kendo-react-inputs";
import { Icon } from "@progress/kendo-react-common";

import {
  DatePicker,
  TimePicker,
  DateTimePicker,
  DateRangePicker,
  DateInput,
} from "@progress/kendo-react-dateinputs";
import {
  Label,
  Error,
  Hint,
  FloatingLabel,
} from "@progress/kendo-react-labels";

import { Upload } from "@progress/kendo-react-upload";
import {
  DropDownList,
  AutoComplete,
  MultiSelect,
  ComboBox,
  MultiColumnComboBox,
  MultiSelectChangeEvent,
} from "@progress/kendo-react-dropdowns";

import { Dialog } from "@progress/kendo-react-dialogs";

import { Alert } from "./alert";
import { FormattedMessage, useIntl } from "react-intl";

interface columnsInterface {
  field: string;
  header: any;
  width: string;
}

export const FormFileUpload = (fieldRenderProps: FieldRenderProps) => {
  const {
    value,
    id,
    label,
    hint,
    validationMessage,
    touched,
    optional,
    disabled,
    onChange,
    accountId,
    buttonText,
    infoText,
    selectedFileName,
    fileNameInitial,
    target,
    ...others
  } = fieldRenderProps;

  const hiddenFileInput = React.useRef<HTMLInputElement>(null);
  const showValidationMessage = touched && validationMessage;
  const showHint = !showValidationMessage && hint;
  const labelId = `${id}_label`;
  const hintId = showHint ? `${id}_hint` : "";
  const errorId = showValidationMessage ? `${id}_error` : "";

  const handleButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    hiddenFileInput.current?.click();
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      const fileName = file.name;
      console.log("File name to upload adfafwewrawerw", fileName);

      console.log("File to upload", file);

      const url = `Customer-Info/acct-${accountId}/${fileName}`;
      console.log("File selected:", fileName, "File URL:", url);
    }
  };
  return (
    <FieldWrapper>
      <Label
        id={labelId}
        editorId={id}
        editorValid={!showValidationMessage}
        editorDisabled={disabled}
        optional={optional}
      >
        {label}
      </Label>
      <div>
        <Button
          themeColor="primary"
          className="font-bold"
          disabled={disabled}
          onClick={handleButtonClick}
        >
          <FormattedMessage id="formControls.uploadCustLogo" />
          {buttonText}
        </Button>
        <input
          type="file"
          id={id}
          className="hidden"
          ref={hiddenFileInput}
          onChange={handleFileChange}
          accept=".png,.jpeg,.jpg"
          disabled={disabled}
          {...others}
        />
      </div>

      {value && (
        <div className="mt-2">
          <strong>
            {/* Uploaded Logo: */}
            {infoText}
            {selectedFileName}
          </strong>
        </div>
      )}

      {showHint && <Hint id={hintId}>{hint}</Hint>}
      {showValidationMessage && <Error id={errorId}>{validationMessage}</Error>}
    </FieldWrapper>
  );
};
export const FormInput = (fieldRenderProps: FieldRenderProps) => {
  const {
    validationMessage,
    touched,
    label,
    id,
    valid,
    disabled,
    hint,
    type,
    optional,
    ...others
  } = fieldRenderProps;

  const showValidationMessage: string | false | null =
    touched && validationMessage;
  const showHint: boolean = !showValidationMessage && hint;
  const hintId: string = showHint ? `${id}_hint` : "";
  const errorId: string = showValidationMessage ? `${id}_error` : "";

  return (
    <FieldWrapper>
      <div className={"k-form-field-wrap"}>
        <Input
          valid={valid}
          type={type}
          id={id}
          label={label}
          disabled={disabled}
          ariaDescribedBy={`${hintId} ${errorId}`}
          {...others}
        />
        {showHint && <Hint id={hintId}>{hint}</Hint>}
        {showValidationMessage && (
          <Error id={errorId}>{validationMessage}</Error>
        )}
      </div>
    </FieldWrapper>
  );
};

export const FormRadioGroup = (fieldRenderProps: FieldRenderProps) => {
  const {
    validationMessage,
    touched,
    id,
    label,
    valid,
    disabled,
    hint,
    visited,
    modified,
    defaultValue,
    ...others
  } = fieldRenderProps;
  const editorRef = React.useRef<any>(null);

  const showValidationMessage: string | false | null =
    touched && validationMessage;
  const showHint: boolean = !showValidationMessage && hint;
  const hintId: string = showHint ? `${id}_hint` : "";
  const errorId: string = showValidationMessage ? `${id}_error` : "";
  const labelId: string = label ? `${id}_label` : "";

  const options = others.options || [];

  return (
    <FieldWrapper>
      <Label
        id={labelId}
        editorRef={editorRef}
        editorId={id}
        editorValid={valid}
        editorDisabled={disabled}
      >
        {label}
      </Label>
      <RadioGroup
        ariaDescribedBy={`${hintId} ${errorId}`}
        ariaLabelledBy={labelId}
        valid={valid}
        disabled={disabled}
        ref={editorRef}
        {...others}
        className="flex relative items-center justify-between"
      />
      {showHint && <Hint id={hintId}>{hint}</Hint>}
      {showValidationMessage && <Error id={errorId}>{validationMessage}</Error>}
    </FieldWrapper>
  );
};

export const FormRadioGroupStatus = (fieldRenderProps: FieldRenderProps) => {
  const intl = useIntl();
  const {
    validationMessage,
    touched,
    id,
    label,
    valid,
    disabled,
    hint,
    visited,
    modified,
    // value,
    onChange,
    defaultValue,

    ...others
  } = fieldRenderProps;
  const editorRef = React.useRef<any>(null);

  const showValidationMessage: string | false | null =
    touched && validationMessage;
  const showHint: boolean = !showValidationMessage && hint;
  const hintId: string = showHint ? `${id}_hint` : "";
  const errorId: string = showValidationMessage ? `${id}_error` : "";
  const labelId: string = label ? `${id}_label` : "";

  const options = others.options || [];

  const [isWarningVisible, setWarningVisible] = useState(false);
  const [selectedValue, setSelectedValue] = useState("");

  const handleRadioChange = (e: any) => {
    console.log("print the selected value for radio", e.value);
    const selectedValue = e.value;
    setSelectedValue(selectedValue);

    if (selectedValue === "disabled") {
      setWarningVisible(true);
    } else {
      onChange({ value: selectedValue });
    }
  };
  const handleDialogConfirm = () => {
    onChange({ value: "disabled" }); // Confirm and update form value
    setWarningVisible(false);
  };

  return (
    <FieldWrapper>
      <Label
        id={labelId}
        editorRef={editorRef}
        editorId={id}
        editorValid={valid}
        editorDisabled={disabled}
      >
        {label}
      </Label>
      <RadioGroup
        ariaDescribedBy={`${hintId} ${errorId}`}
        ariaLabelledBy={labelId}
        valid={valid}
        disabled={disabled}
        ref={editorRef}
        {...others}
        className="flex relative items-center justify-between"
        onChange={handleRadioChange}
      />
      {showHint && <Hint id={hintId}>{hint}</Hint>}
      {showValidationMessage && <Error id={errorId}>{validationMessage}</Error>}
      {isWarningVisible && (
        <Dialog className="warningDialogue">
          <Alert
            description={intl.formatMessage({
              id: "formControls.disableUserAlert",
            })}
            buttonText={intl.formatMessage({ id: "users.buttonText.Ok" })}
            // failureText={"Cancel"}
            icon={"warningShape.png"}
            iconMsg={intl.formatMessage({ id: "iconMsgWarning" })}
            backgroundColor={"mk-orange"}
            onClick={handleDialogConfirm} // Update on confirm
          />
        </Dialog>
      )}
    </FieldWrapper>
  );
};

export const FormRadioGroupChange = (fieldRenderProps: FieldRenderProps) => {
  const {
    validationMessage,
    touched,
    id,
    label,
    valid,
    disabled,
    hint,
    visited,
    modified,
    ...others
  } = fieldRenderProps;
  const editorRef = React.useRef<any>(null);

  const showValidationMessage: string | false | null =
    touched && validationMessage;
  const showHint: boolean = !showValidationMessage && hint;
  const hintId: string = showHint ? `${id}_hint` : "";
  const errorId: string = showValidationMessage ? `${id}_error` : "";
  const labelId: string = label ? `${id}_label` : "";

  return (
    <FieldWrapper>
      <Label
        id={labelId}
        editorRef={editorRef}
        editorId={id}
        editorValid={valid}
        editorDisabled={disabled}
      >
        {label}
      </Label>
      <RadioGroup
        ariaDescribedBy={`${hintId} ${errorId}`}
        ariaLabelledBy={labelId}
        valid={valid}
        disabled={disabled}
        ref={editorRef}
        {...others}
      />
      {showHint && <Hint id={hintId}>{hint}</Hint>}
      {showValidationMessage && <Error id={errorId}>{validationMessage}</Error>}
    </FieldWrapper>
  );
};

export const FormNumericTextBox = (fieldRenderProps: FieldRenderProps) => {
  const {
    validationMessage,
    touched,
    label,
    id,
    valid,
    disabled,
    value,
    hint,
    min,
    max,
    ...others
  } = fieldRenderProps;

  const showValidationMessage: string | false | null =
    touched && validationMessage;
  const showHint: boolean = !showValidationMessage && hint;
  const hintId: string = showHint ? `${id}_hint` : "";
  const errorId: string = showValidationMessage ? `${id}_error` : "";

  return (
    <FieldWrapper>
      <Label editorId={id} editorValid={valid} editorDisabled={disabled}>
        {label}
      </Label>
      <NumericTextBox
        ariaDescribedBy={`${hintId} ${errorId}`}
        valid={valid}
        id={id}
        value={value}
        min={min}
        max={max}
        disabled={disabled}
        {...others}
      />
      {showHint && <Hint id={hintId}>{hint}</Hint>}
      {showValidationMessage && <Error id={errorId}>{validationMessage}</Error>}
    </FieldWrapper>
  );
};

export const FormCheckbox = (fieldRenderProps: FieldRenderProps) => {
  const {
    validationMessage,
    touched,
    id,
    valid,
    disabled,
    hint,
    optional,
    label,
    visited,
    modified,
    ...others
  } = fieldRenderProps;

  const showValidationMessage: string | false | null =
    touched && validationMessage;
  const showHint: boolean = !showValidationMessage && hint;
  const hintId: string = showHint ? `${id}_hint` : "";
  const errorId: string = showValidationMessage ? `${id}_error` : "";

  return (
    <FieldWrapper>
      <Checkbox
        ariaDescribedBy={`${hintId} ${errorId}`}
        label={label}
        labelOptional={optional}
        valid={valid}
        id={id}
        disabled={disabled}
        {...others}
      />
      {showHint && <Hint id={hintId}>{hint}</Hint>}
      {showValidationMessage && <Error id={errorId}>{validationMessage}</Error>}
    </FieldWrapper>
  );
};

export const FormSwitch = (fieldRenderProps: FieldRenderProps) => {
  const {
    validationMessage,
    touched,
    label,
    optional,
    id,
    valid,
    disabled,
    hint,
    ...others
  } = fieldRenderProps;
  const editorRef = React.useRef<any>(null);

  const showValidationMessage: string | false | null =
    touched && validationMessage;
  const showHint: boolean = !showValidationMessage && hint;
  const hintId: string = showHint ? `${id}_hint` : "";
  const errorId: string = showValidationMessage ? `${id}_error` : "";
  const labelId: string = label ? `${id}_label` : "";

  return (
    <FieldWrapper>
      <Label
        id={labelId}
        editorRef={editorRef}
        editorId={id}
        editorValid={valid}
        editorDisabled={disabled}
        optional={optional}
      >
        {label}
      </Label>
      <Switch
        ref={editorRef}
        ariaLabelledBy={labelId}
        ariaDescribedBy={`${hintId} ${errorId}`}
        valid={valid}
        id={id}
        disabled={disabled}
        {...others}
      />
      {showHint && <Hint id={hintId}>{hint}</Hint>}
      {showValidationMessage && <Error id={errorId}>{validationMessage}</Error>}
    </FieldWrapper>
  );
};

export const FormMaskedTextBox = (fieldRenderProps: FieldRenderProps) => {
  const {
    validationMessage,
    value,
    touched,
    label,
    id,
    valid,
    hint,
    optional,
    onChange,
    onFocus,
    maxLength,
    placeholder,
    ...others
  } = fieldRenderProps;

  const showValidationMessage: string | false | null =
    touched && validationMessage;
  const showHint: boolean = !showValidationMessage && hint;
  const hintId: string = showHint ? `${id}_hint` : "";
  const errorId: string = showValidationMessage ? `${id}_error` : "";

  const [controlValue, setControlValue] = useState(value);

  const handleInputChange = (ev: any) => {
    const inputValue = ev.target.value;

    if (inputValue === "") {
      setControlValue("");
      onChange({ target: { value: "" } });
    } else {
      if (inputValue.length <= maxLength) {
        setControlValue(inputValue);
      }
    }
    onChange(ev);
  };
  const handleClearValue = () => {
    setControlValue("");
    onChange({ target: { value: "" } });
  };

  return (
    <FieldWrapper>
      <Label editorId={id} editorValid={valid} optional={optional}>
        {label}
      </Label>
      <div className={"k-form-field-wrap"}>
        <MaskedTextBox
          ariaDescribedBy={`${hintId} ${errorId}`}
          valid={valid}
          id={id}
          value={controlValue}
          placeholder={placeholder}
          suffix={() => (
            <>
              {controlValue && (
                <InputClearValue onClick={handleClearValue}>
                  <Icon name="x" />
                </InputClearValue>
              )}
            </>
          )}
          onChange={handleInputChange}
          onFocus={onFocus}
          {...others}
        />
        {showHint && <Hint id={hintId}>{hint}</Hint>}
        {showValidationMessage && (
          <Error id={errorId}>{validationMessage}</Error>
        )}
      </div>
    </FieldWrapper>
  );
};

export const FormTextArea = (fieldRenderProps: FieldRenderProps) => {
  const {
    validationMessage,
    touched,
    label,
    id,
    valid,
    hint,
    disabled,
    optional,
    maxLength,
    ...others
  } = fieldRenderProps;

  const showValidationMessage: string | false | null =
    touched && validationMessage;
  const showHint: boolean = !showValidationMessage && hint;
  const hintId: string = showHint ? `${id}_hint` : "";
  const errorId: string = showValidationMessage ? `${id}_error` : "";

  return (
    <FieldWrapper>
      <Label editorId={id} editorValid={valid} optional={optional}>
        {label}
      </Label>
      <TextArea
        valid={valid}
        id={id}
        disabled={disabled}
        ariaDescribedBy={`${hintId} ${errorId}`}
        maxLength={maxLength}
        {...others}
      />
      {showHint && <Hint id={hintId}>{hint}</Hint>}
      {showValidationMessage && <Error id={errorId}>{validationMessage}</Error>}
    </FieldWrapper>
  );
};

export const FormColorPicker = (fieldRenderProps: FieldRenderProps) => {
  const {
    validationMessage,
    touched,
    label,
    id,
    valid,
    disabled,
    hint,
    wrapperStyle,
    ...others
  } = fieldRenderProps;
  const editorRef = React.useRef<any>(null);

  const showValidationMessage: string | false | null =
    touched && validationMessage;
  const showHint: boolean = !showValidationMessage && hint;
  const hintId: string = showHint ? `${id}_hint` : "";
  const errorId: string = showValidationMessage ? `${id}_error` : "";
  const labelId: string = label ? `${id}_label` : "";

  return (
    <FieldWrapper style={wrapperStyle}>
      <Label
        id={labelId}
        editorRef={editorRef}
        editorId={id}
        editorValid={valid}
        editorDisabled={disabled}
      >
        {label}
      </Label>
      <ColorPicker
        ariaLabelledBy={labelId}
        ariaDescribedBy={`${hintId} ${errorId}`}
        ref={editorRef}
        valid={valid}
        id={id}
        disabled={disabled}
        {...others}
      />
      {showHint && <Hint id={hintId}>{hint}</Hint>}
      {showValidationMessage && <Error id={errorId}>{validationMessage}</Error>}
    </FieldWrapper>
  );
};

export const FormRating = (fieldRenderProps: FieldRenderProps) => {
  const {
    validationMessage,
    touched,
    label,
    id,
    valid,
    hint,
    disabled,
    optional,
    ...others
  } = fieldRenderProps;

  const showValidationMessage: string | false | null =
    touched && validationMessage;
  const showHint: boolean = !showValidationMessage && hint;
  const hintId: string = showHint ? `${id}_hint` : "";
  const errorId: string = showValidationMessage ? `${id}_error` : "";

  return (
    <FieldWrapper>
      <Label editorId={id} editorValid={valid} optional={optional}>
        {label}
      </Label>
      <Rating
        valid={valid}
        id={id}
        disabled={disabled}
        ariaDescribedBy={`${hintId} ${errorId}`}
        {...others}
      />
      {showValidationMessage && <Error id={errorId}>{validationMessage}</Error>}
    </FieldWrapper>
  );
};

export const FormUpload = (fieldRenderProps: FieldRenderProps) => {
  const {
    value,
    id,
    optional,
    label,
    hint,
    validationMessage,
    touched,
    accept,
    ...others
  } = fieldRenderProps;

  const showValidationMessage: string | false | null =
    touched && validationMessage;
  const showHint: boolean = !showValidationMessage && hint;
  const hintId: string = showHint ? `${id}_hint` : "";
  const errorId: string = showValidationMessage ? `${id}_error` : "";
  const labelId: string = label ? `${id}_label` : "";

  const onChangeHandler = (event: any) => {
    fieldRenderProps.onChange({ value: event.newState });
  };
  const onRemoveHandler = (event: any) => {
    fieldRenderProps.onChange({ value: event.newState });
  };

  return (
    <FieldWrapper>
      <Label id={labelId} editorId={id} optional={optional}>
        {label}
      </Label>
      <Upload
        id={id}
        autoUpload={false}
        showActionButtons={false}
        multiple={false}
        files={value}
        onAdd={onChangeHandler}
        onRemove={onRemoveHandler}
        ariaDescribedBy={`${hintId} ${errorId}`}
        ariaLabelledBy={labelId}
        accept={accept}
        saveUrl={"https://demos.telerik.com/kendo-ui/service-v4/upload/save"}
        removeUrl={
          "https://demos.telerik.com/kendo-ui/service-v4/upload/remove"
        }
        {...others}
      />
      {showHint && <Hint id={hintId}>{hint}</Hint>}
      {showValidationMessage && <Error id={errorId}>{validationMessage}</Error>}
    </FieldWrapper>
  );
};

// export const FormDropDownList = (fieldRenderProps: FieldRenderProps) => {
//   const {
//     validationMessage,
//     data,
//     touched,
//     label,
//     id,
//     valid,
//     defaultValue,
//     placeholder,
//     disabled,
//     hint,
//     wrapperStyle,
//     ...others
//   } = fieldRenderProps;

//   const editorRef = React.useRef<any>(null);

//   const showValidationMessage: string | false | null =
//     touched && validationMessage;
//   const showHint: boolean = !showValidationMessage && hint;
//   const hintId: string = showHint ? `${id}_hint` : "";
//   const errorId: string = showValidationMessage ? `${id}_error` : "";
//   const labelId: string = label ? `${id}_label` : "";

//   return (
//     <FieldWrapper style={wrapperStyle}>
//       <Label
//         id={labelId}
//         editorRef={editorRef}
//         editorId={id}
//         editorValid={valid}
//         editorDisabled={disabled}
//       >
//         {label}
//       </Label>
//       <div
//         className="k-form-field-wrap"
//         style={{
//           display: "inline-block",
//           // border: "1px solid var(--color-mk-primary)",
//           border: !showValidationMessage
//             ? "1px solid var(--color-mk-primary)" // Red border for errors
//             : "", // Blue border by default

//           borderRadius: "4px",
//           // padding: "2px 6px",
//         }}
//       >
//         <DropDownList
//           data={data}
//           ariaLabelledBy={labelId}
//           ariaDescribedBy={`${hintId} ${errorId}`}
//           ref={editorRef}
//           valid={valid}
//           id={id}
//           disabled={disabled}
//           defaultItem={defaultValue}
//           {...others}
//         />
//         {/* {showHint && <Hint id={hintId}>{hint}</Hint>}
//         {showValidationMessage && (
//           <Error id={errorId}>{validationMessage}</Error>
//         )} */}
//       </div>
//       {showHint && <Hint id={hintId}>{hint}</Hint>}
//       {showValidationMessage && <Error id={errorId}>{validationMessage}</Error>}
//     </FieldWrapper>
//   );
// };

export const FormDropDownList = (fieldRenderProps: FieldRenderProps) => {
  const {
    validationMessage,
    data,
    touched,
    label,
    id,
    valid,
    defaultValue,
    placeholder,
    disabled,
    hint,
    wrapperStyle,
    className,
    style,
    ...others
  } = fieldRenderProps;

  const editorRef = React.useRef<any>(null);

  const showValidationMessage: string | false | null =
    touched && validationMessage;
  const showHint: boolean = !showValidationMessage && hint;
  const hintId: string = showHint ? `${id}_hint` : "";
  const errorId: string = showValidationMessage ? `${id}_error` : "";
  const labelId: string = label ? `${id}_label` : "";

  return (
    <FieldWrapper style={wrapperStyle}>
      <Label
        id={labelId}
        editorRef={editorRef}
        editorId={id}
        editorValid={valid}
        editorDisabled={disabled}
      >
        {label}
      </Label>

      <div
        className={`k-form-field-wrap ${className || ""}`}
        style={{
          display: "inline-block",
          // minWidth: "200px", // Ensures it doesn't collapse
          // width: "100%", // Uses width from class or container
          border: !showValidationMessage
            ? "1px solid var(--color-mk-primary)"
            : "",
          borderRadius: "4px",
          ...style, // custom inline style passed via <Field />
        }}
      >
        <DropDownList
          data={data}
          ariaLabelledBy={labelId}
          ariaDescribedBy={`${hintId} ${errorId}`}
          ref={editorRef}
          valid={valid}
          id={id}
          disabled={disabled}
          defaultItem={defaultValue}
          // style={{ width: "100%" }} // makes it fill the wrapper
          {...others}
        />
      </div>

      {showHint && <Hint id={hintId}>{hint}</Hint>}
      {showValidationMessage && <Error id={errorId}>{validationMessage}</Error>}
    </FieldWrapper>
  );
};

export const FormAutoComplete = (fieldRenderProps: FieldRenderProps) => {
  const {
    validationMessage,
    touched,
    label,
    id,
    valid,
    disabled,
    hint,
    wrapperStyle,
    ...others
  } = fieldRenderProps;
  const editorRef = React.useRef<any>(null);

  const showValidationMessage: string | false | null =
    touched && validationMessage;
  const showHint: boolean = !showValidationMessage && hint;
  const hintId: string = showHint ? `${id}_hint` : "";
  const errorId: string = showValidationMessage ? `${id}_error` : "";
  const labelId: string = label ? `${id}_label` : "";

  return (
    <FieldWrapper style={wrapperStyle}>
      <Label
        id={labelId}
        editorRef={editorRef}
        editorId={id}
        editorValid={valid}
        editorDisabled={disabled}
      >
        {label}
      </Label>
      <AutoComplete
        ariaLabelledBy={labelId}
        ariaDescribedBy={`${hintId} ${errorId}`}
        ref={editorRef}
        valid={valid}
        id={id}
        disabled={disabled}
        {...others}
      />
      {showHint && <Hint id={hintId}>{hint}</Hint>}
      {showValidationMessage && <Error id={errorId}>{validationMessage}</Error>}
    </FieldWrapper>
  );
};

export const FormComboBox = (fieldRenderProps: FieldRenderProps) => {
  const {
    validationMessage,
    touched,
    label,
    id,
    valid,
    disabled,
    hint,
    wrapperStyle,
    ...others
  } = fieldRenderProps;
  const editorRef = React.useRef<any>(null);

  const showValidationMessage: string | false | null =
    touched && validationMessage;
  const showHint: boolean = !showValidationMessage && hint;
  const hintId: string = showHint ? `${id}_hint` : "";
  const errorId: string = showValidationMessage ? `${id}_error` : "";
  const labelId: string = label ? `${id}_label` : "";

  return (
    <FieldWrapper style={wrapperStyle}>
      <Label
        id={labelId}
        editorRef={editorRef}
        editorId={id}
        editorValid={valid}
        editorDisabled={disabled}
      >
        {label}
      </Label>
      <ComboBox
        ariaLabelledBy={labelId}
        ariaDescribedBy={`${hintId} ${errorId}`}
        ref={editorRef}
        valid={valid}
        id={id}
        disabled={disabled}
        {...others}
      />
      {showHint && <Hint id={hintId}>{hint}</Hint>}
      {showValidationMessage && <Error id={errorId}>{validationMessage}</Error>}
    </FieldWrapper>
  );
};

export const FormMultiColumnComboBox = (fieldRenderProps: FieldRenderProps) => {
  const {
    validationMessage,
    touched,
    label,
    id,
    valid,
    disabled,
    hint,
    wrapperStyle,
    ...others
  } = fieldRenderProps;
  const editorRef = React.useRef<any>(null);

  const showValidationMessage: string | false | null =
    touched && validationMessage;
  const showHint: boolean = !showValidationMessage && hint;
  const hintId: string = showHint ? `${id}_hint` : "";
  const errorId: string = showValidationMessage ? `${id}_error` : "";
  const labelId: string = label ? `${id}_label` : "";

  const columns: Array<columnsInterface> = [
    { field: "id", header: <span>header</span>, width: "100px" },
    { field: "name", header: "Name", width: "300px" },
    { field: "position", header: "Position", width: "300px" },
  ];

  return (
    <FieldWrapper style={wrapperStyle}>
      <Label
        id={labelId}
        editorRef={editorRef}
        editorId={id}
        editorValid={valid}
        editorDisabled={disabled}
      >
        {label}
      </Label>
      <MultiColumnComboBox
        ariaLabelledBy={labelId}
        ariaDescribedBy={`${hintId} ${errorId}`}
        ref={editorRef}
        valid={valid}
        id={id}
        disabled={disabled}
        columns={columns}
        textField={"name"}
        {...others}
      />
      {showHint && <Hint id={hintId}>{hint}</Hint>}
      {showValidationMessage && <Error id={errorId}>{validationMessage}</Error>}
    </FieldWrapper>
  );
};

export const FormMultiSelect = (fieldRenderProps: FieldRenderProps) => {
  const {
    validationMessage,
    touched,
    label,
    id,
    valid,
    disabled,
    hint,
    wrapperStyle,
    ...others
  } = fieldRenderProps;
  const editorRef = React.useRef<any>(null);
  const showValidationMessage = touched && validationMessage;
  const showHint = !showValidationMessage && hint;
  const hintId = showHint ? `${id}_hint` : "";
  const errorId = showValidationMessage ? `${id}_error` : "";
  const labelId = label ? `${id}_label` : "";

  return (
    <FieldWrapper style={wrapperStyle}>
      <Label
        id={labelId}
        editorRef={editorRef}
        editorId={id}
        editorValid={valid}
        editorDisabled={disabled}
      >
        {label}
      </Label>
      <MultiSelect
        ariaLabelledBy={labelId}
        ariaDescribedBy={`${hintId} ${errorId}`}
        ref={editorRef}
        valid={valid}
        id={id}
        disabled={disabled}
        {...others}
      />
      {showHint && <Hint id={hintId}>{hint}</Hint>}
      {showValidationMessage && <Error id={errorId}>{validationMessage}</Error>}
    </FieldWrapper>
  );
};

export const FormMultiSelectAdd = (fieldRenderProps: FieldRenderProps) => {
  const {
    validationMessage,
    touched,
    label,
    id,
    valid,
    disabled,
    hint,
    wrapperStyle,
    onChange,
    ...others
  } = fieldRenderProps;
  const editorRef = React.useRef<any>(null);
  const showValidationMessage = touched && validationMessage;
  const showHint = !showValidationMessage && hint;
  const hintId = showHint ? `${id}_hint` : "";
  const errorId = showValidationMessage ? `${id}_error` : "";
  const labelId = label ? `${id}_label` : "";

  const [value, setValue] = useState<string[]>([]);

  const handleChange = (event: MultiSelectChangeEvent) => {
    const values = event.target.value;
    const lastItem = values[values.length - 1];

    if (lastItem) {
      values.pop();
      const sameItem = values.find((value) => value === lastItem);
      if (sameItem === undefined) {
        values.push(lastItem);
      }
    }
    setValue(values);
  };

  return (
    <FieldWrapper style={wrapperStyle}>
      <Label
        id={labelId}
        editorRef={editorRef}
        editorId={id}
        editorValid={valid}
        editorDisabled={disabled}
      >
        {label}
      </Label>
      <MultiSelect
        ariaLabelledBy={labelId}
        ariaDescribedBy={`${hintId} ${errorId}`}
        ref={editorRef}
        valid={valid}
        id={id}
        disabled={disabled}
        allowCustom={true}
        onChange={handleChange}
        {...others}
      />
      {showHint && <Hint id={hintId}>{hint}</Hint>}
      {showValidationMessage && <Error id={errorId}>{validationMessage}</Error>}
    </FieldWrapper>
  );
};

// export const FormDatePicker = (fieldRenderProps: FieldRenderProps) => {
//   const {
//     validationMessage,
//     touched,
//     label,
//     id,
//     valid,
//     disabled,
//     hint,
//     wrapperStyle,
//     hintDirection,
//     onChange,
//     value,
//     // min,
//     // max,
//     ...others
//   } = fieldRenderProps;

//   const showValidationMessage: string | false | null =
//     touched && validationMessage;
//   const showHint: boolean = !showValidationMessage && hint;
//   const hintId: string = showHint ? `${id}_hint` : "";
//   const errorId: string = showValidationMessage ? `${id}_error` : "";
//   const labelId: string = label ? `${id}_label` : "";
//   const todaysDate = new Date();

//   const handleDateChange = (event: any) => {
//     const dateValue = event.value === null ? "" : event.value;
//     if (onChange) {
//       onChange({
//         ...event,
//         value: dateValue,
//       });
//     }
//   };
//   return (
//     <FieldWrapper style={wrapperStyle}>
//       <Label
//         id={labelId}
//         editorId={id}
//         editorValid={valid}
//         editorDisabled={disabled}
//       >
//         {label}
//       </Label>
//       <div className={"k-form-field-wrap"}>
//         <DatePicker
//           onChange={handleDateChange}
//           ariaLabelledBy={labelId}
//           ariaDescribedBy={`${hintId} ${errorId}`}
//           valid={valid}
//           id={id}
//           value={value ? new Date(value) : undefined}
//           disabled={disabled}
//           format="dd/MM/yyyy"
//           // max={max}
//           {...others}
//         />
//         {showHint && (
//           <Hint id={hintId} direction={hintDirection}>
//             {hint}
//           </Hint>
//         )}
//         {showValidationMessage && (
//           <Error id={errorId}>{validationMessage}</Error>
//         )}
//       </div>
//     </FieldWrapper>
//   );
// };

export const FormDatePicker = (fieldRenderProps: FieldRenderProps) => {
  const {
    validationMessage,
    touched,
    label,
    id,
    disabled,
    hint,
    wrapperStyle,
    hintDirection,
    onChange,
    value,
    ...others
  } = fieldRenderProps;

  const showHint: boolean = hint && !(touched && validationMessage);
  const hintId: string = showHint ? `${id}_hint` : "";
  const labelId: string = label ? `${id}_label` : "";

  const handleDateChange = (event: any) => {
    const dateValue = event.value === null ? "" : event.value;
    if (onChange) {
      onChange({
        ...event,
        value: dateValue,
      });
    }
  };

  return (
    <FieldWrapper style={wrapperStyle}>
      <Label id={labelId} editorId={id} editorDisabled={disabled}>
        {label}
      </Label>
      <div className={"k-form-field-wrap"}>
        <DatePicker
          onChange={handleDateChange}
          ariaLabelledBy={labelId}
          ariaDescribedBy={`${hintId}`} // Removed errorId
          id={id}
          value={value ? new Date(value) : undefined}
          disabled={disabled}
          format="dd/MM/yyyy"
          {...others}
        />
        {showHint && (
          <Hint id={hintId} direction={hintDirection}>
            {hint}
          </Hint>
        )}
      </div>
    </FieldWrapper>
  );
};

export const FormDateTimePicker = (fieldRenderProps: FieldRenderProps) => {
  const {
    validationMessage,
    touched,
    label,
    id,
    valid,
    disabled,
    hint,
    wrapperStyle,
    ...others
  } = fieldRenderProps;

  const showValidationMessage: string | false | null =
    touched && validationMessage;
  const showHint: boolean = !showValidationMessage && hint;
  const hintId: string = showHint ? `${id}_hint` : "";
  const errorId: string = showValidationMessage ? `${id}_error` : "";
  const labelId: string = label ? `${id}_label` : "";

  return (
    <FieldWrapper style={wrapperStyle}>
      <Label
        id={labelId}
        editorId={id}
        editorValid={valid}
        editorDisabled={disabled}
      >
        {label}
      </Label>
      <DateTimePicker
        ariaLabelledBy={labelId}
        ariaDescribedBy={`${hintId} ${errorId}`}
        valid={valid}
        id={id}
        disabled={disabled}
        {...others}
      />
      {showHint && <Hint id={hintId}>{hint}</Hint>}
      {showValidationMessage && <Error id={errorId}>{validationMessage}</Error>}
    </FieldWrapper>
  );
};

export const FormTimePicker = (fieldRenderProps: FieldRenderProps) => {
  const {
    validationMessage,
    touched,
    label,
    id,
    valid,
    disabled,
    hint,
    wrapperStyle,
    ...others
  } = fieldRenderProps;

  const showValidationMessage: string | false | null =
    touched && validationMessage;
  const showHint: boolean = !showValidationMessage && hint;
  const hintId: string = showHint ? `${id}_hint` : "";
  const errorId: string = showValidationMessage ? `${id}_error` : "";
  const labelId: string = label ? `${id}_label` : "";

  return (
    <FieldWrapper style={wrapperStyle}>
      <Label
        id={labelId}
        editorId={id}
        editorValid={valid}
        editorDisabled={disabled}
      >
        {label}
      </Label>
      <TimePicker
        ariaLabelledBy={labelId}
        ariaDescribedBy={`${hintId} ${errorId}`}
        valid={valid}
        id={id}
        disabled={disabled}
        {...others}
      />
      {showHint && <Hint id={hintId}>{hint}</Hint>}
      {showValidationMessage && <Error id={errorId}>{validationMessage}</Error>}
    </FieldWrapper>
  );
};

export const FormDateInput = (fieldRenderProps: FieldRenderProps) => {
  const {
    validationMessage,
    touched,
    label,
    id,
    valid,
    disabled,
    hint,
    wrapperStyle,
    ...others
  } = fieldRenderProps;

  const showValidationMessage: string | false | null =
    touched && validationMessage;
  const showHint: boolean = !showValidationMessage && hint;
  const hintId: string = showHint ? `${id}_hint` : "";
  const errorId: string = showValidationMessage ? `${id}_error` : "";
  const labelId: string = label ? `${id}_label` : "";

  return (
    <FieldWrapper style={wrapperStyle}>
      <Label
        id={labelId}
        editorId={id}
        editorValid={valid}
        editorDisabled={disabled}
      >
        {label}
      </Label>
      <DateInput
        ariaLabelledBy={labelId}
        ariaDescribedBy={`${hintId} ${errorId}`}
        valid={valid}
        id={id}
        disabled={disabled}
        {...others}
      />
      {showHint && <Hint id={hintId}>{hint}</Hint>}
      {showValidationMessage && <Error id={errorId}>{validationMessage}</Error>}
    </FieldWrapper>
  );
};

export const FormDateRangePicker = (fieldRenderProps: FieldRenderProps) => {
  const {
    validationMessage,
    touched,
    label,
    id,
    valid,
    disabled,
    hint,
    wrapperStyle,
    ...others
  } = fieldRenderProps;
  const editorRef = React.useRef<any>(null);

  const showValidationMessage: string | false | null =
    touched && validationMessage;
  const showHint: boolean = !showValidationMessage && hint;
  const hintId: string = showHint ? `${id}_hint` : "";
  const errorId: string = showValidationMessage ? `${id}_error` : "";
  const labelId: string = label ? `${id}_label` : "";

  return (
    <FieldWrapper style={wrapperStyle}>
      <Label
        id={labelId}
        editorRef={editorRef}
        editorId={id}
        editorValid={valid}
        editorDisabled={disabled}
      >
        {label}
      </Label>
      <DateRangePicker
        ariaLabelledBy={labelId}
        ariaDescribedBy={`${hintId} ${errorId}`}
        ref={editorRef}
        valid={valid}
        id={id}
        disabled={disabled}
        {...others}
      />
      {showHint && <Hint id={hintId}>{hint}</Hint>}
      {showValidationMessage && <Error id={errorId}>{validationMessage}</Error>}
    </FieldWrapper>
  );
};

export const FormFloatingNumericTextBox = (
  fieldRenderProps: FieldRenderProps
) => {
  const {
    validationMessage,
    touched,
    label,
    id,
    valid,
    disabled,
    hint,
    optional,
    value,
    ...others
  } = fieldRenderProps;

  const showValidationMessage: string | false | null =
    touched && validationMessage;
  const showHint: boolean = !showValidationMessage && hint;
  const hintId: string = showHint ? `${id}_hint` : "";
  const errorId: string = showValidationMessage ? `${id}_error` : "";

  return (
    <FieldWrapper>
      <FloatingLabel
        optional={optional}
        editorValue={value}
        editorId={id}
        editorValid={valid}
        editorDisabled={disabled}
        label={label}
      >
        <NumericTextBox
          ariaDescribedBy={`${hintId} ${errorId}`}
          value={value}
          valid={valid}
          id={id}
          disabled={disabled}
          {...others}
        />
      </FloatingLabel>
      {showHint && <Hint id={hintId}>{hint}</Hint>}
      {showValidationMessage && <Error id={errorId}>{validationMessage}</Error>}
    </FieldWrapper>
  );
};

export const FormLabeledInput = (fieldRenderProps: FieldRenderProps) => {
  const {
    validationMessage,
    touched,
    label,
    id,
    valid,
    disabled,
    hint,
    type,
    optional,
    maxLength,
    ...others
  } = fieldRenderProps;

  const showValidationMessage: string | false | null =
    touched && validationMessage;
  const showHint: boolean = !showValidationMessage && hint;
  const hintId: string = showHint ? `${id}_hint` : "";
  const errorId: string = showValidationMessage ? `${id}_error` : "";

  return (
    <FieldWrapper>
      <Label editorId={id} editorValid={valid} editorDisabled={disabled}>
        {label}
      </Label>
      <Input
        valid={valid}
        type={type}
        id={id}
        disabled={disabled}
        ariaDescribedBy={`${hintId} ${errorId}`}
        maxLength={maxLength}
        {...others}
      />

      {showValidationMessage && <Error id={errorId}>{validationMessage}</Error>}
    </FieldWrapper>
  );
};

export const FormLabeledInputMobile = (fieldRenderProps: FieldRenderProps) => {
  const {
    validationMessage,
    touched,
    label,
    id,
    valid,
    disabled,
    hint,
    type,
    optional,
    maxLength,
    value,
    onChange,
    onFocus,
    ...others
  } = fieldRenderProps;

  const showValidationMessage: string | false | null =
    touched && validationMessage;
  const showHint: boolean = !showValidationMessage && hint;
  const hintId: string = showHint ? `${id}_hint` : "";
  const errorId: string = showValidationMessage ? `${id}_error` : "";

  const [controlValue, setControlValue] = useState(value);
  const [hasFocus, setHasFocus] = useState(false);

  const handleInputChange = (ev: any) => {
    const inputValue = ev.target.value;

    if (inputValue === "") {
      setControlValue("");
    } else {
      if (inputValue.length <= maxLength) {
        setControlValue(inputValue);
      }
    }
    onChange(ev);
  };

  const handleInputFocus = () => {
    if (!hasFocus) {
      setControlValue(""); // Clear the default value when the input gains focus
      setHasFocus(true);
    }
  };

  return (
    <FieldWrapper>
      <Label editorId={id} editorValid={valid} editorDisabled={disabled}>
        {label}
      </Label>
      <Input
        valid={valid}
        type={type}
        id={id}
        disabled={disabled}
        ariaDescribedBy={`${hintId} ${errorId}`}
        maxLength={maxLength}
        onChange={handleInputChange}
        onFocus={handleInputFocus}
        {...others}
      />

      {showValidationMessage && (
        <Error className="mb-[-7%]" id={errorId}>
          {validationMessage}
        </Error>
      )}
    </FieldWrapper>
  );
};

export const FormMaskedTextBoxMobile = (fieldRenderProps: FieldRenderProps) => {
  const {
    validationMessage,
    value,
    touched,
    label,
    id,
    valid,
    hint,
    optional,
    onChange,
    onFocus,
    maxLength,
    placeholder,
    ...others
  } = fieldRenderProps;

  const showValidationMessage: string | false | null =
    touched && validationMessage;
  const showHint: boolean = !showValidationMessage && hint;
  const hintId: string = showHint ? `${id}_hint` : "";
  const errorId: string = showValidationMessage ? `${id}_error` : "";

  const [controlValue, setControlValue] = useState(value);
  const [hasFocus, setHasFocus] = useState(false);

  const handleInputChange = (ev: any) => {
    const inputValue = ev.target.value;

    if (inputValue === "") {
      setControlValue("");
      onChange({ target: { value: "" } });
    } else {
      if (inputValue.length <= maxLength) {
        setControlValue(inputValue);
      }
    }
    onChange(ev);
  };
  const handleClearValue = () => {
    setControlValue("");
    onChange({ target: { value: "" } });
  };

  return (
    <FieldWrapper>
      <Label
        className="ml-[-35%]"
        editorId={id}
        editorValid={valid}
        optional={optional}
      >
        {label}
      </Label>
      <div className={"k-form-field-wrap"}>
        <MaskedTextBox
          ariaDescribedBy={`${hintId} ${errorId}`}
          valid={valid}
          id={id}
          value={controlValue}
          suffix={() => (
            <>
              {/* {controlValue && (
                <InputClearValue
                  onClick={() => {
                    setControlValue("");
                  }}
                >
                  <Icon name="x" />
                </InputClearValue>
              )} */}

              {controlValue && (
                <InputClearValue onClick={handleClearValue}>
                  <Icon name="x" />
                </InputClearValue>
              )}
            </>
          )}
          onChange={handleInputChange}
          onFocus={onFocus}
          // onFocus={handleInputFocus}

          {...others}
        />
        {showHint && <Hint id={hintId}>{hint}</Hint>}
        {showValidationMessage && (
          <Error className="mb-[-7%] ml-[-35%]" id={errorId}>
            {validationMessage}
          </Error>
        )}
      </div>
    </FieldWrapper>
  );
};
